import Button from 'components/common/Button';
import Text from 'components/common/Text';

const searchTerms = ['Oven Ready', 'Chicken', 'Keto'];

const MenuSearchDropdown = ({ handleSearch }) => {
  return (
    <div className="flex flex-col rounded-lg border border-solid border-[#BABABA] bg-white-100 p-4 shadow-md">
      <Text className="textMd mb-2 text-charcoal-90">Popular</Text>
      {searchTerms.map(searchTerm => (
        <Button
          variation="Ghost"
          className="mb-2 px-4 py-0 text-left text-[#232323] hover:bg-green-50"
          key={searchTerm}
          onClick={() => handleSearch({ params: { searchTerm: searchTerm } })}
        >
          {searchTerm}
        </Button>
      ))}
    </div>
  );
};

MenuSearchDropdown.propTypes = {
  handleSearch: PropTypes.func,
};

export default MenuSearchDropdown;
